export const initialPatch = { phase: "idle", file: "", filePercent: 0, totalPercent: 0, done: 0, total: 0, text: "", error: "" };

const HANDLERS = {
  status: (s, p) => ({ ...s, phase: "checking", text: p.text }),
  check: (s, p) => ({ ...s, phase: p.needed ? "downloading" : "done", total: p.needed, totalPercent: p.needed ? 0 : 100 }),
  progress: (s, p) => ({ ...s, phase: "downloading", file: p.File, filePercent: p.FilePercent, totalPercent: p.TotalPercent, done: p.Done, total: p.Total }),
  done: (s, p) => ({ ...s, phase: "done", done: s.total, totalPercent: 100, filePercent: 100, text: `Zaktualizowano plików: ${p.updated}` }),
  error: (s, p) => ({ ...s, phase: "error", error: p.message }),
};

export const applyHostMessage = (state, type, payload) => (HANDLERS[type] ? HANDLERS[type](state, payload) : state);

export const demoFrame = (files, index, percent) => ({
  phase: "downloading",
  file: files[index].path,
  filePercent: percent,
  total: files.length,
  done: index,
  totalPercent: ((index + percent / 100) / files.length) * 100,
});
